import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { UserRole } from '../../types';

/**
 * Redirects to the appropriate home page based on the user's role.
 * - 'SUPER_ADMIN' → /tenants
 * - TENANT_ADMIN, SALES_REP → /dashboard
 * - Not authenticated → /login
 */
const RoleRedirect: React.FC = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const userRole = useAuthStore((s) => s.user?.role);

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (userRole === UserRole.SUPER_ADMIN) {
    return <Navigate to="/tenants" replace />;
  }

  if (userRole === UserRole.GROUP_ADMIN) {
    return <Navigate to="/group-admin" replace />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default RoleRedirect;
